<div class="relative inline-block w-full">
  @if (label) {
  <label [attr.for]="triggerId" class="block text-xs font-semibold text-[#25282D] mb-1">
    {{ label }}
    @if (showAsterisk) {
    <span class="text-orange-500 text-xs font-semibold">*</span>
    }
  </label>
  }
  <!-- Dropdown trigger: single-select with inline clear, or default button -->
  @if (!multiSelect && showClearButton) {
  <div [ngClass]="getClearableTriggerClasses()">
    <button
      #dropdownTrigger
      [id]="triggerId"
      type="button"
      (click)="toggleDropdown($event)"
      class="flex-1 min-w-0 border-0 bg-transparent text-[12px] text-gray-700 py-2 pl-2 pr-1 flex items-center text-left outline-none focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="disabled"
    >
      <span
        [ngClass]="{
          '!text-black': selectedOption,
          '!text-[#96A0B5]': !selectedOption
        }"
        class="flex items-center gap-1.5 flex-wrap flex-1 min-w-0 text-left"
      >
        {{
          (optionDisplay && selectedOption ? optionDisplay[selectedOption] : null) ??
            (selectedOption || placeholder)
        }}
        @if (optionBadges && selectedOption && optionBadges[selectedOption]) {
        <span
          class="text-[10px] font-medium text-[#6B7280] bg-[#E5E7EB] px-1.5 py-0.5 rounded"
          >{{ optionBadges[selectedOption] }}</span
        >
        }
      </span>
    </button>
    @if (selectedOption && !disabled) {
    <button
      type="button"
      (click)="onTriggerClear($event)"
      class="shrink-0 self-center flex items-center justify-center p-1 mr-0.5 rounded text-[#96A0B5] hover:text-[#25282D] hover:bg-gray-200/80 transition-colors"
      aria-label="Clear selection"
      title="Clear"
    >
      <svg
        class="w-3.5 h-3.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        stroke-width="2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
    }
    <button
      type="button"
      (click)="toggleDropdown($event)"
      class="shrink-0 flex items-center justify-center py-2 pr-2 pl-1 border-0 bg-transparent text-gray-600 outline-none focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="disabled"
      tabindex="-1"
      aria-hidden="true"
    >
      <svg
        class="w-4 h-4 transition-transform"
        [class.rotate-180]="isOpen"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        ></path>
      </svg>
    </button>
  </div>
  } @else {
  <button
    #dropdownTrigger
    [id]="triggerId"
    type="button"
    (click)="toggleDropdown($event)"
    [ngClass]="getButtonClasses()"
    [disabled]="disabled"
  >
    @if (multiSelect) {
    <span
      [ngClass]="{
        '!text-black': selectedValues.length,
        '!text-[#96A0B5]': !selectedValues.length
      }"
      class="flex items-center gap-1 flex-wrap text-left"
    >
      @if (selectedValues.length === 0) {
      <span>{{ placeholder }}</span>
      } @else if (selectedValues.length > 2) {
      <span>{{ getMultiSelectDisplayValues(selectedValues.slice(0, 2)).join(", ") }}</span>
      <span
        class="text-purple-600 font-semibold bg-purple-100 text-center px-2 h-4.5 rounded-[8px] text-[11px]"
        >+ {{ selectedValues.length - 2 }}</span
      >
      } @else {
      <span>{{ getMultiSelectDisplayValues(selectedValues).join(", ") }}</span>
      }
    </span>
    } @if (!multiSelect) {
    <span
      [ngClass]="{
        '!text-black': selectedOption,
        '!text-[#96A0B5]': !selectedOption
      }"
      class="flex items-center gap-1.5 flex-wrap"
    >
      {{ ((optionDisplay && selectedOption ? optionDisplay[selectedOption] : null) ?? (selectedOption || placeholder)) }}
      @if (optionBadges && selectedOption && optionBadges[selectedOption]) {
        <span class="text-[10px] font-medium text-[#6B7280] bg-[#E5E7EB] px-1.5 py-0.5 rounded">{{ optionBadges[selectedOption] }}</span>
      }
    </span>
    }

    <svg
      class="w-4 h-4 ml-2 transition-transform"
      [class.rotate-180]="isOpen"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 9l-7 7-7-7"
      ></path>
    </svg>
  </button>
  }

  <!-- Dropdown Menu -->
  @if (isOpen) {
  <div
    #dropdownMenu
    class="w-full bg-white border border-gray-300 rounded-md shadow-lg z-[100] form-select-dropdown-list"
    [ngClass]="[
      listItemClass,
      effectiveOpenUpward
        ? 'absolute left-0 right-0 bottom-full mb-0'
        : 'absolute left-0 right-0 top-full mt-2'
    ]"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    @if (enableSearch) {
    <div class="p-1.5 border-b border-gray-200">
      <div class="relative">
        <svg
          class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          ></path>
        </svg>
        <input
          #searchInput
          type="text"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Search..."
          class="w-full pl-8 py-1.5 text-[12px] border border-gray-300 rounded-md focus:outline-none"
          (click)="$event.stopPropagation()"
        />
      </div>
    </div>
    }
    <ul
      class="overflow-y-auto overflow-x-hidden custom-scrollbar max-h-56"
      [style.max-height.px]="maxHeight"
    >
      @if (optionGroups?.length && !enableSearch) {
        @for (group of optionGroups; track group.label) {
          <li class="px-3 py-1.5 text-[11px] font-semibold text-gray-500 uppercase tracking-wide bg-gray-100 cursor-default border-t border-gray-200 first:border-t-0">
            {{ group.label }}
          </li>
          @for (option of group.options; track option) {
            <li
              (click)="selectOption(option)"
              (keydown)="onOptionKeydown($event, option)"
              class="px-3 py-1 text-[12px] focus::bg-gray-100 cursor-pointer flex items-center gap-2 transition-colors"
            >
              @if (multiSelect) {
              <div
                class="relative flex items-center justify-center w-[15px] h-[15px] border rounded-[4px] border-gray-300 transition-all duration-200"
                [ngClass]="{
                  'bg-purple-600 border-purple-600': isSelected(option),
                  'bg-white border-gray-300': !isSelected(option)
                }"
              >
                @if (isSelected(option)) {
                <svg
                  class="w-3 h-3 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                }
              </div>
              }
              <span class="flex-1 text-gray-900">{{ option }}</span>
            </li>
          }
        }
      } @else {
      @for (option of (enableSearch ? filteredOptions : selectableOptions); track $index)
      {
      <li
        (click)="selectOption(option)"
        (keydown)="onOptionKeydown($event, option)"
        class="px-3 py-1 text-[12px] focus::bg-gray-100 cursor-pointer flex items-center gap-2 transition-colors"
      >
        @if (multiSelect) {
        <div
          class="relative flex items-center justify-center w-[15px] h-[15px] border rounded-[4px] border-gray-300 transition-all duration-200"
          [ngClass]="{
            'bg-purple-600 border-purple-600': isSelected(option),
            'bg-white border-gray-300': !isSelected(option)
          }"
        >
          @if (isSelected(option)) {
          <svg
            class="w-3 h-3 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="3"
              d="M5 13l4 4L19 7"
            ></path>
          </svg>
          }
        </div>
        }
        <span class="flex-1 text-gray-900 flex items-center gap-1.5 flex-wrap">
          {{ (optionDisplay && optionDisplay[option] !== undefined ? optionDisplay[option] : option) }}
          @if (optionBadges && optionBadges[option]) {
            <span class="text-[10px] font-medium text-[#6B7280] bg-[#E5E7EB] px-1.5 py-0.5 rounded">{{ optionBadges[option] }}</span>
          }
        </span>
      </li>
      }
      }
      @if (enableSearch && filteredOptions.length === 0 && searchQuery.trim())
      {
      <li class="px-3 py-1.5 text-[12px] text-gray-500 text-center">
        No results found
      </li>
      }
    </ul>
  </div>
  }

  <!-- Error Message -->
  @if (showError && errorMessage) {
  <div class="mt-1 text-xs text-red-500">
    {{ errorMessage }}
  </div>
  }
</div>
